import { render, staticRenderFns } from "./ProtocolsList.vue?vue&type=template&id=285f0872&"
import script from "./ProtocolsList.vue?vue&type=script&lang=js&"
export * from "./ProtocolsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports